module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5N8ZA"))).then(() => parcelRequire('2KbAe'));